import React, {Component} from 'react';
import PropTypes from 'prop-types';

class Checkbox extends Component {
  static propTypes = {
    checked: PropTypes.bool,
    label: PropTypes.any,
    name: PropTypes.string,
    value: PropTypes.number,
    onChange: PropTypes.func,
    required: PropTypes.bool,
    small: PropTypes.bool,
    disabled: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.state = {
      value: props.value,
      checked: props.checked,
    };
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.checked !== this.props.checked ||
      prevProps.value !== this.props.value
    ) {
      this.setState({
        value: this.props.value,
        checked: this.props.checked,
      });
    }
  }

  onChange = e => {
    const {value} = this.state;
    const {name, onChange, disabled} = this.props;

    if (disabled) return;

    const newValue = value === 1 ? 0 : 1;
    const checked = newValue === 1;

    this.setState({
      value: newValue,
      checked: checked,
    });

    if (onChange) onChange(newValue, name);
  };

  render() {
    const {label, name, required, small, disabled} = this.props;
    const {value, checked} = this.state;
    const labelClass = ['checkbox__handle'];
    if (small) labelClass.push('checkbox__handle_small');

    return (
      <div className="checkbox">
        <label className={labelClass.join(' ')}>
          <input
            type="checkbox"
            checked={checked}
            name={name}
            value={value}
            onChange={this.onChange}
            disabled={disabled}
            required={required}
          />
          <span></span>
        </label>
        <div className="checkbox__label" onClick={this.onChange}>{label}</div>
      </div>
    );
  }
}

export default Checkbox;
